<template>
  <div class="">
    <login-after-head-center></login-after-head-center>
    <div id="member" class="container home-container flex">
      <side-nav></side-nav>
      <div class="address-manage">
        <div class="home-allTitle award-title-cg">
          <span>收货地址</span>

          <p class="add-address">
            <a href="" @click.prevent="add()">新增收货地址</a>
          </p>
        </div>

        <div class=" address-bg fc-bet" v-for="(item) in addressList" :key="item.id">
          <div class="address-box">
            <span class="address-text ">{{item.realName}}</span>
            <span class="">{{item.phone}}</span>
             <span class="first-address " v-if="item.isDefault">默认地址</span>
            <p class="">{{item.province + item.city + item.district + item.detail}}</p>
          </div>
          <div class="address-del">
            <a @click="setDefault(item.id)" class="set-address" v-if="!item.isDefault">设为默认地址</a>
            <a href="javascript:void(0)" class="address-lh " @click="edit(item)">编辑</a>
            <a @click="del(item.id)" class="address-lh ">删除</a>
          </div>
        </div>

        <!--        <div class=" address-bg fc-bet">-->
        <!--          <div class="address-box">-->
        <!--            <span class="address-text ">王楠</span>-->
        <!--            <span class="">133****1217</span>-->
        <!--            <span class="first-address ">默认地址</span>-->
        <!--            <p class="">河北省唐山市古冶区111</p>-->
        <!--          </div>-->
        <!--          <div class="address-del">-->
        <!--            &lt;!&ndash; <a href="javascript:void(0)" class="set-address" >设为默认地址</a> &ndash;&gt;-->
        <!--            <a href="javascript:void(0)" class="address-lh " @click="showAddressPop = true">编辑</a>-->
        <!--            <a href="javascript:void(0)" class="address-lh ">删除</a>-->
        <!--          </div>-->

        <!--        </div>-->

        <!--        <div class=" address-bg fc-bet">-->
        <!--          <div class="address-box">-->
        <!--            <span class="address-text ">王楠</span>-->
        <!--            <span class="">133****1217</span>-->
        <!--            &lt;!&ndash; <span class="first-address ">默认地址</span> &ndash;&gt;-->
        <!--            <p class="">河北省唐山市古冶区111</p>-->
        <!--          </div>-->
        <!--          <div class="address-del">-->
        <!--            <a href="javascript:void(0)" class="set-address">设为默认地址</a>-->
        <!--            <a href="javascript:void(0)" class="address-lh " @click="showAddressPop = true">编辑</a>-->
        <!--            <a href="javascript:void(0)" class="address-lh ">删除</a>-->
        <!--          </div>-->
        <!--        </div>-->


      </div>
    </div>
    <i-footer></i-footer>
    <fixed-right></fixed-right>


    <el-dialog title="新增收货人信息" :visible.sync="showAddressPop" width="750px" custom-class="pop-class">

      <el-form ref="form" :model="form" label-width="87px" :rules="rules">
        <el-form-item label="收货人" prop="real_name">
          <div style="width: 172px;">
            <el-input v-model="form.real_name" placeholder="请输入姓名"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="所在地址" prop="selectedOptions">

          <div style="width: 330px;">
            <el-cascader
                :options="areaSelectData"
                @change="handleChange"
                class="full-width"
                size="large"
                v-model="form.selectedOptions"
                placeholder="请选择您所在的城市"
            />

          </div>

        </el-form-item>
        <el-form-item label="详细地址" prop="detail">
          <div style="width:307px;">
            <el-input v-model="form.detail" placeholder="街道名称编号 楼宇名称 单位 房间"></el-input>
          </div>
        </el-form-item>
        <div class="clear-mt"></div>
        <el-form-item label="手机号码" prop="phone">
          <div style="width: 172px;">
            <el-input v-model="form.phone" placeholder="常用的手机号码"></el-input>
          </div>
<!--          <p class="tips">-->
<!--            用来接收订单提醒邮件，便于您及时了解订单状态-->
<!--          </p>-->
        </el-form-item>
        <el-form-item>
          <div @click="submitForm('form')" class="onSubmit">保存收货人信息</div>
        </el-form-item>
        <div style="height: 20px;"></div>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="showAddressPop = false">取 消</el-button>
        <el-button type="primary" @click="showAddressPop = false">确 定</el-button>
      </span> -->
    </el-dialog>


  </div>
</template>

<script>


import {regionData, CodeToText, TextToCode} from "element-china-area-data";
import {
  getCityData,
  getAddressData,
  setDefaultAddress,
  deleteAddress,
  editAddressData
} from '@/api/user.js'

export default {

  data() {
    return {
      addressList: [],
      //省市区三级联动数据
      areaSelectData: regionData,
      showAddressPop: false,
      form: {
        real_name: null,
        phone: null,
        address: {
          city: null,
          cityId: null,
          district: null,
          province: null
        },
        id: null,
        detail: null,
        is_default: false
      },
      rules: {
        real_name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
          {min: 2, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请填写手机号', trigger: 'blur'},
          {min: 11, max: 11, message: '请填写手机号', trigger: 'blur'}
        ],
        detail: [
          {required: true, message: '街道名称编号 楼宇名称 单位 房间', trigger: 'blur'},
          {min: 5, max: 20, message: '长度在 5 到 20 个字符', trigger: 'blur'}
        ],
        selectedOptions: [
          {required: true, message: '请选择您所在的城市', trigger: 'change'}
        ]
      }
    }
  },
  mounted() {
    this.getAddressList()
    // this.getCityList()

  },
  methods: {
    // 获取地址列表
    async getAddressList() {
      var res = await getAddressData()
      if (res.status === 200) {
        this.addressList = res.data
      } else {
        this.$message.warning(res.msg)
      }
    },
    add () {
      this.showAddressPop = true
      this.form= {
        real_name: null,
            phone: null,
            address: {
              city: null,
              cityId: null,
              district: null,
              province: null
        },
        id: null,
        detail: null,
        is_default: false
      }
    }
    ,
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        console.info("地址表单为====》", this.form)
        if (valid) {
          if (!this.form.real_name) {
            return this.$message.warning('请输入收货人姓名')
          } else if (!this.form.phone) {
            return this.$message.warning('请输入联系电话')
          } else if (!this.form.address) {
            return this.$message.warning('请选择省市区')
          } else if (!this.form.detail) {
            return this.$message.warning('请输入详细地址')
          }
          editAddressData(this.form).then(res => {
            if (res.status === 200) {
              this.getAddressList()
              this.$message.success(this.form.id ? '修改成功' : '添加成功')
              this.showAddressPop = false
            } else {
              this.$message.warning(res.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑
    edit (item) {
      this.form.selectedOptions = []
      this.areaSelectData.forEach(i => {
        console.info("循环地址信息为====》",i)
        if (i.label === item.province) {
          this.form.address.province = i.label
          this.form.selectedOptions.push(i.value)
          i.children.forEach(j => {
            if (j.label === item.city) {
              this.form.address.city = j.label
              this.form.address.cityId = j.value
              this.form.selectedOptions.push(j.value)
              j.children.forEach(k => {
                if (k.label === item.district) {
                  this.form.address.district = k.label
                  this.form.selectedOptions.push(k.value)
                }
              })
            }
          })
        }
      })
      this.form.real_name = item.realName
      this.form.phone = item.phone
      this.form.detail = item.detail
      this.form.id = item.id
      this.showAddressPop = true
    }
    ,
    // 设为默认地址
    setDefault(id) {
      console.info("调用设置默认地址")
      setDefaultAddress({id}).then(res => {
        if (res.status === 200) {
          console.info("设置默认地址结果====》",res)
          this.getAddressList()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 删除地址
    del(id) {
      this.$confirm('此操作将永久删除该地址, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAddress({id}).then(res => {
          if (res.status === 200) {
            this.$message.success('删除成功')
            this.getAddressList()
          } else {
            this.$message.warning(res.msg)
          }
        })
      }).catch(() => {
      })
    }
    ,
    handleChange(value) {
      //value为省市区code数组
      if (value) {
        var provinceCode = CodeToText[value[0]];//code转为省
        var cityCode = CodeToText[value[1]];//市
        var orgion = CodeToText[value[2]];//区
        var address = {};
        address.province = provinceCode;
        address.city = cityCode;
        address.district = orgion;

        this.form.address = address
        // this.form.selectedOptions = provinceCode + cityCode + orgion;
      }else {
        this.form.address = {
          city: null,
          cityId: null,
          province: null,
          district: null
        }
      }

    }

  },


}
</script>

<style lang="less">
.full-width {
  width: 100%;

  .el-input__suffix {

    overflow: hidden;
  }
}
</style>
